import React, { useId, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * A company's or an expert's presentation, folded to a few lines with "Se mer" when it is
 * long, so one company does not push the others down the page.
 */
export function FoldedPresentation({ html }: { html: string }) {
  const { t } = useTranslation();
  const body = useRef<HTMLDivElement>(null);
  const [long, setLong] = useState(false);
  const [open, setOpen] = useState(false);
  const id = useId();
  useLayoutEffect(() => {
    const element = body.current;
    if (element) setLong(element.scrollHeight > element.clientHeight + 1);
  }, [html]);
  return (
    <>
      <div
        ref={body}
        id={id}
        className={`ql-editor p-0 company-card-presentation${open ? ' is-open' : ''}${long && !open ? ' is-folded' : ''}`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {(long || open) && (
        <button
          type="button"
          className="company-card-more"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen(value => !value)}
        >
          {open ? t('myCompanies.showLess') : t('myCompanies.showMore')}
          <i className={`feather-chevron-${open ? 'up' : 'down'} ms-1`} aria-hidden="true"></i>
        </button>
      )}
    </>
  );
}
